export const zhMessage = {
  Chinese: '中文',
  English: '英文',
  common: {
    login: 'login'
  },
  system: {
    id_type: 'system'
  },
  student: {
    id_type: 'student'
  },
  setting: {
    setting: '设置',
    unit: '单位设置',
    person: '个人设置'
  },
  userName: '用户名/证件号',
  password: '密码',
  passwordLimit: '8-16位字母(区分大小写)和数字组合',
  oldPassword: '原密码',
  oldPasswordPlaceholder: '请输入原密码',
  newPassword: '新密码',
  newPasswordPlaceholder: '请输入新密码',
  confirmPassword: '确认密码',
  confirmPasswordLimit: '两次密码不一致',
  confirmPasswordPlaceholder: '请输入确认密码',
  modify: '修改',
  permission: '教案权限设置',
  editPassword: '修改密码',
  editPhone: '修改手机号',
  home: '首页',
  refresh: '刷新',
  quit: '退出',
  coach: '教练',
  coachAccount: '教练帐号',
  coach1: '主教练',
  coachPlaceholder: '请选择主教练',
  coachName: '教练姓名',
  coachInformation: '教练信息',
  trainer: '选择助理教练',
  title: '上海市星级足球培训机构评定系统',
  competent: '主管部门',
  chineseFootballAssociation: '上海市体育局/上海市足球协会',
  service: '保障客服',
  serviceWeChat: '客服微信',
  technicalSupport: '技术支持',
  telephone: '服务电话',
  phone: '电话',
  mobilePhoneNumber: '手机号',
  mobilePhonePlaceholder: '请输入正确的手机号',
  registeredPhone: '该手机号已经被注册',
  registeredIdNumber: '该身份证号已经被注册',
  code: '验证码',
  codePlaceHolder: '请输入验证码',
  codeFormatTips: '请输入正确的验证码',
  newMobilePhoneNumber: '新的手机号',
  newMobilePhoneNumberPlaceholder: '请输入新的手机号',
  warmTips: '温馨提示：修改成功后，请使用新的手机号登录',
  yioks: '一刻',
  playerManagement: '球员管理',
  addPlayer: '添加球员',
  addLeader: '添加领队',
  editLeader: '编辑领队',
  bulkImportPlayers: '批量添加球员',
  bulkImportLeaders: '批量导入领队帐号',
  allPlayers: '全部球员',
  namePlaceholder: '请输入球员姓名',
  phonePlaceholder: '请输入手机号',
  search: '搜索',
  edit: '编辑',
  delete: '删除',
  bindingTeam: '绑定球队',
  editPlayer: '编辑球员',
  name: '姓名',
  team: '所选球队',
  team1: '技术等级',
  teams: '全部等级',
  teamPlayers: '全队球员',
  playersNum: '球员数量',
  position: '位置',
  unit: '单位',
  profilePhoto: '上传头像',
  operation: '操作',
  headPortrait: '头像',
  idNumber: '证件号码',
  idNumberPlaceholder: '请输入证件号码',
  positionPlaceholder: '请选择球员位置',
  unitName: '单位名称',
  unitPlaceholder: '请输入单位名称',
  unitPhonePlaceholder: '请输入单位联系电话',
  teamPlaceholder: '请选择球队',
  SquadNameBusy: '该球队名称已被占用',
  MasterCoachBusy: '该主教练已存在其他球队',
  LeaderBusy: '该领队已存在其他球队',
  CoachBusy: '教练数据更新，请刷新页面后重试',
  confirm: '确定',
  save: '保存',
  cancel: '取消',
  deletePlayerTips: '确定删除该球员?',
  deleteTeamTips: '确定删除该球队?',
  nameTips: '请输入姓名',
  idNumberTips: '请输入正确的证件号码',
  playerInformation: '球员信息',
  basicInformation: '基本信息',
  age: '年龄',
  gender: '性别',
  genderPlaceholder: '请选择性别',
  birthday: '生日',
  birthPlace: '籍贯',
  leader: '领队',
  leaderStatus: '领队状态',
  leaderAccount: '领队帐号',
  leaderName: '领队姓名',
  leaderInformation: '领队信息',
  leaderPlaceholder: '请选择领队',
  executiveCoach: '主教练',
  coachTeams: '教练团队',
  players: '球员',
  player: '球员',
  managementTeam: '管理球队',
  teamManagement: '球队管理',
  trainingTimeStatistics: '训练时长统计',
  totalTrainingTime: '训练总时长',
  hour: '小时',
  hours: '小时',
  minutes: '分钟',
  minute: '分钟',
  people: '人',
  editTeam: '编辑球队',
  teachingPlansNum: '教案数量',
  private: '私有',
  internal: '内部',
  look: '查看',
  adjustPlayer: '调整球员',
  uploadFormat: '支持jpg,jpeg,bmp,gif,png格式上传',
  fileSizeLimit: '上传图片的大小不能超过 10MB',
  quitTips: '确定退出登录吗？',
  or: '或',
  uploadTipsFirst: '请上传 excel 文件 ',
  uploadTipsSecond: '下载模板',
  uploadTipsThird: ' 编辑后上传',
  noData: '暂时没有数据~',
  clickOnUpload: '点击上传',
  hardLoading: '努力加载中...',
  addTeam: '添加球队',
  addCoach: '添加教练',
  editCoach: '编辑教练',
  coachStatus: '编辑教练',
  bulkImportCoaches: '批量导入教练帐号',
  totalTeamNums: '全部球队',
  all: '全部',
  shortName: '球队简称',
  shortNamePlaceholder: '请先选择球队',
  teamName: '球队全称',
  waivedSubmission: '确定放弃修改并返回吗?',
  temporarilySaveAndReturn: '确定暂时保存并返回吗?',
  saveAndReturnPre: '确定暂时保存并返回上一步吗?',
  status: '状态',
  keyWordsPlaceholder: '请输入关键字',
  allLeaders: '领队数量',
  allCoaches: '教练数量',
  loginTips: '* 该手机号将作为领队的初始密码，身份证号作为登录帐号',
  teachingPlans: '教案数量',
  createdTeachingPlans: '创建的教案数量',
  total: '总数',
  more: '更多',
  addPlayersTips: '点击 "+" 添加球员',
  removePlayersTips: '点击 "-" 移除球员',
  otherPlayers: '其他球员',
  existingPlayers: '球队现有球员',
  trainingPlan: '训练计划',
  trainingPlanPlaceholder: '请输入训练总结',
  planNamePlaceholder: '请输入教案名字',
  completedPlan: '已完成计划',
  pendingPlan: '待实施计划',
  writingPlan: '编写中计划',
  addPlan: '添加计划',
  trainingStartTime: '训练开始时间',
  download: '下载',
  completedConfirm: '完成确认',
  deletePlanTips: '确定删除该训练计划吗?',
  backPlanTips: '确定退回该训练计划吗?',
  deleteTeachingPlanTips: '确定删除该教案么?',
  addOrEditPlan: '添加/编辑训练计划',
  writingPlanStepOne: '第一步：编写训练计划',
  writingPlanStepTwo: '第二步：确认计划实施',
  writingPlanStepThree: '第三步：训练评价',
  chiefCoach: '主教练',
  train: '训练',
  trainingVolume: '训练量',
  trainingIntensity: '训练强度',
  trainingPlanDescription: '训练计划总体描述',
  trainingPlace: '训练地点',
  placeTips: '请选择训练地点',
  templatePlan: '选择教案',
  templatePlanTips: '请选择教案',
  choosePlan: '选择训练教案',
  nextStep: '下一步',
  previousStep: '上一步',
  temporarilySave: '暂时保存',
  timePlaceholder: '请选择时间',
  trainingTopic: '训练主题',
  linkTitle: '环节标题',
  planTitle: '教案标题',
  show: '显示',
  linkDescription: '环节说明',
  trainingTopicPlaceholder: '请输入训练主题',
  generalDescription: '训练总体描述',
  trainingDescription: '训练描述',
  classification: '分类',
  type: '分类',
  classifications: '全部分类',
  classificationPlaceholder: '请选择分类主题',
  trainingDuration: '训练时长（分钟）',
  totalTimes: '训练时长合计 (分钟)',
  author: '作者',
  lastUpdateTime: '最后更新时间',
  language: '语言',
  confirmPlan: '选择教案',
  planSearchTips: '请输入教案名',
  noFlashTips: '浏览器没有启动或没有安装Flash Player，因此无法正常播放~~',
  youCan: '您可以',
  startFlash: '立即启用或安装Flash Player播放器',
  confirmRoster: '确认球队球员名单',
  open: '开启',
  close: '关闭',
  group: '分组',
  groupA: 'A组球员',
  groupB: 'B组球员',
  mustOnePlayer: '每组至少有一位球员',
  iKnow: '我知道了',
  trainingSummary: '全队训练表现',
  playersAttendance: '球员出勤',
  attendance: '出勤率',
  playerEvaluation: '是否进行球员评价',
  evaluation: '球员评价',
  trainingGoal: '训练目标',
  trainingGoalPlaceholder: '请输入训练目标',
  overallEvaluationOpinion: '总体评价意见',
  allEvaluation: '总体评价',
  advice: '建议',
  advicePlaceholder: '请输入建议',
  overallEvaluationOpinionPlaceholder: '请输入总体评价意见',
  psychological: '心智能力',
  physical: '体能',
  tactical: '战术能力',
  technology: '技术能力',
  overall: '社交能力',
  points: '分',
  select: '请选择',
  defaultPlaceholder: '请输入内容',
  project: '项目',
  duration: '时长',
  linkDuration: '环节时长',
  ge: '个',
  yioksLibrary: '参考教案',
  officialLibrary: '教练共享',
  organLibrary: '教练共享',
  youthLibrary: '教练共享',
  myPlan: '我的教案',
  collectionPlans: '收藏的教案',
  createPlan: '创建教案',
  createMatchPlan: '创建比赛',
  quicklyCreate: '快速创建教案',
  confirmCreate: '确认创建',
  collect: '收藏',
  removeCollection: '取消收藏',
  copyPlan: '复制教案',
  downloadPlan: '下载教案',
  editPlan: '编辑教案',
  editMatchPlan: '编辑比赛',
  removePlan: '删除教案',
  salute: '点赞',
  allLinks: '全部环节',
  linkType: '环节分类',
  link: '环节',
  queryTrainingContent: '查询训练内容',
  professionalFootballCoach: '专业足球教练',
  sharedPermission: '共享权限',
  lookBySelf: '仅个人可看',
  sharedTeam: '内部可看',
  provincePlaceholder: '请选择省份',
  cityPlaceholder: '请选择市',
  uploadFileTips: '请删除前一次上传的文件后再重新提交。',
  uploadExcelTips: '请上传Excel文件!',
  uploadExcelSizeTips: '文件大小不能超过20M！',
  importNow: '立即导入',
  lookDetail: '查看详情',
  planLimitTips: '最多可以选择5个环节',
  planEditor: '训练教案编辑器',
  sendCode: '发送验证码',
  centerManagement: '青训中心管理',
}
